import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettings } from "../../Redux/WebsiteSlice";
import { useBookingModal } from "../../context/BookingModalContext";
import logo from "../../assets/img/footer logo.webp";

const Footer = () => {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.website.settings);
  const { openModal } = useBookingModal();

  const handleQuickLink = (e, sectionId) => {
    e.preventDefault();
    const isHomePage = window.location.pathname === '/';
    if (isHomePage) {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerOffset = 100;
        const top = element.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    } else {
      window.location.href = '/#' + sectionId;
    }
  };

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);

  const getImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http')) return url;
    if (url.startsWith('/uploads/')) {
      const base =  'https://api-test.swifttoolskit.cloud/api';
      return base + url;
    }
    return url;
  };

  return (
    <div className="physiotherapy-site">
      <section className="hero-section">
        <div className="custom_container">
          <div className="hero-content">
            <div className="booking-info">
              <h1 className="hero-title">Book an Appointment</h1>
              <p className="hero-text">
                Call us on {settings?.contact?.phone || '(08) 6296 2323'} or click the link below to book
                online.
              </p>
              <button type="button" onClick={() => setTimeout(openModal, 0)} className="book-btn">Book an Appointment</button>
            </div>

            <div className="map-container">
              <iframe
                src={settings?.contact?.selectedLocationId?.mapEmbedUrl || settings?.contact?.mapEmbedUrl || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3387.0!2d115.99!3d-31.76!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzHCsDQ1JzM2LjAiUyAxMTXCsDU5JzI0LjAiRQ!5e0!3m2!1sen!2sau!4v1234567890"}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Cornerstone Physiotherapy Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer-section">
        <div className="custom_container">
          <div className="footer-content">
            <div className="footer-column logo-column">
              <div className="logo-container">
                <div className="logo">
                  <div className="logo-icon">
                    <img 
                      src={settings?.footerLogo ? getImageUrl(settings.footerLogo) : logo} 
                      alt="logo"
                      onError={(e) => {
                        e.target.src = logo;
                      }}
                    />
                  </div>
                  {/* <div className="logo-text">
                    <span className="logo-name">Cornerstone</span>
                    <span className="logo-sub">Physiotherapy</span>
                    <span className="logo-location">AVELEY</span>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="footer-column">
              <h3 className="footer-heading">Quick Links</h3>
              <ul className="footer-links">
                {settings?.headerNavigation && settings.headerNavigation.length > 0 ? (
                  settings.headerNavigation.map((item, index) => {
                    const isHash = item.link && item.link.startsWith('#');
                    const sectionId = isHash ? item.link.substring(1) : null;
                    return (
                      <li key={index}>
                        {isHash ? (
                          <a href={`/#${sectionId}`} onClick={(e) => handleQuickLink(e, sectionId)}>{item.title}</a>
                        ) : (
                          <a href={item.link}>{item.title}</a>
                        )}
                      </li>
                    );
                  })
                ) : (
                  <>
                    <li>
                      <a href="/#Services" onClick={(e) => handleQuickLink(e, 'Services')}>Services</a>
                    </li>
                    <li>
                      <a href="/#blog" onClick={(e) => handleQuickLink(e, 'blog')}>Blog</a>
                    </li>
                    <li>
                      <a href="/#team" onClick={(e) => handleQuickLink(e, 'team')}>Our Team</a>
                    </li>
                  </>
                )}
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-heading">Contact Info</h3>
              <ul className="contact-list">
                <li>
                  <strong>Phone:</strong>{" "}
                  <a href={`tel:${settings?.contact?.phone?.replace(/\D/g, '') || '0862962323'}`}>
                    {settings?.contact?.phone || '(08) 6296 2323'}
                  </a>
                </li>
                <li>
                  <strong>Email:</strong>{" "}
                  <a href={`mailto:${settings?.contact?.email || 'explane@explane.com.au'}`}>
                    {settings?.contact?.email || 'explane@explane.com.au'}
                  </a>
                </li>
                <li>
                  <strong>Address:</strong>{" "}
                  {settings?.contact?.address?.street || 'Suite 1, Level 1 Aveley Medical Centre, 15 Flecker Promenade'}
                  <br />
                  {settings?.contact?.address?.city || 'AVELEY WA 6069'}
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-heading">Opening Hours</h3>
              <ul className="hours-list">
                {settings?.openingHours && settings.openingHours.length > 0 ? (
                  settings.openingHours.map((hour, index) => (
                    <li key={index}>
                      <span>{hour.day}</span>{" "}
                      <span>{hour.isClosed ? 'Closed' : hour.hours || 'Closed'}</span>
                    </li>
                  ))
                ) : (
                  <>
                    <li><span>Monday</span> <span>8am - 7pm</span></li>
                    <li><span>Tuesday</span> <span>8am - 7pm</span></li>
                    <li><span>Wednesday</span> <span>8am - 5pm</span></li>
                    <li><span>Thursday</span> <span>8am - 7pm</span></li>
                    <li><span>Friday</span> <span>8am - 7pm</span></li>
                    <li><span>Saturday</span> <span>8am - 1pm</span></li>
                    <li><span>Sunday</span> <span>Closed</span></li>
                  </>
                )}
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>
              {settings?.footer?.copyrightText || 'Copyright© 2024 Cornerstone Physiotherapy AVELEY. All Right Reserved'}
            </p>
            <div className="footer-social">
              {settings?.socialMedia?.facebook && (
                <a href={settings.socialMedia.facebook} target="_blank" rel="noopener noreferrer" className="footer-social__link" aria-label="Facebook">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                  </svg>
                </a>
              )}
              {settings?.socialMedia?.instagram && (
                <a href={settings.socialMedia.instagram} target="_blank" rel="noopener noreferrer" className="footer-social__link" aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                    <circle cx="12" cy="12" r="4"/>
                    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
                  </svg>
                </a>
              )}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
